import React from 'react';

import { MissingRefReportProvider, type ReportView } from './providers/MissingRefReportProvider';
import MissingRefReportQuery from './components/MissingRefReportQuery';

interface MissingRefReportTabProps {
  /** Hides the internal Moves · Mobile Service switch. */
  lockedView: ReportView;
}

/** The report manages its own full-bleed layout, so it renders bare like the standalone
 *  `/missing-ref` page, which stays unlocked. */
const MissingRefReportTab: React.FC<MissingRefReportTabProps> = ({ lockedView }) => (
  <MissingRefReportProvider lockedView={lockedView}>
    <MissingRefReportQuery />
  </MissingRefReportProvider>
);

export default MissingRefReportTab;
